import { useQuery } from "@tanstack/react-query";

import { getFarms } from "services";

import { getActiveToken, useUserContext } from "utils";

import { GET_FARMS } from "consts";

import { FarmResponse } from "models";

export const useGetFarms = () => {
  const { user } = useUserContext();
  const token = getActiveToken();

  const query = useQuery<FarmResponse[]>({
    queryKey: [GET_FARMS],
    queryFn: getFarms,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!user && !!token, // only fetch if user is logged in
  });

  const currentFarm = query.data?.find((farm) => farm.id === user?.farm.id);

  return {
    currentFarm,
    data: query.data ?? [],
    refetch: query.refetch,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isFetched: query.isFetched,
    isPending: query.isPending,
  };
};
